<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input
                clearable
                v-model="form.name"
                placeholder="请输入姓名"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          
          <el-col :span="12">
            <el-form-item label="电话" prop="tel">
              <el-input
                clearable
                v-model="form.tel"
                placeholder="请输入电话"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row :gutter="24">
          
          <el-col :span="12">
            <el-form-item label="身份证号" prop="idNumber">
              <el-input
                clearable
                v-model="form.idNumber"
                placeholder="请输入身份证号"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="与老人关系" prop="relationship">
              <el-select v-model="form.relationship" placeholder="请选择与老人关系" style="width: 100%">
                <el-option
                  v-for="item in relationshipList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          
        </el-row>
        <el-row :gutter="24">

          <el-col :span="12">
            <el-form-item label="性别" prop="sex">
              <el-radio-group v-model="form.sex">
                <el-radio :label="'1'">男</el-radio>
                <el-radio :label="'0'">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="联系地址" prop="address">
              <el-input
                clearable
                v-model="form.address"
                placeholder="请输入联系地址"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row :gutter="24">
          

          <el-col :span="12">
            <el-form-item label="是否为监护人" prop="isGuardian">
              <el-select v-model="form.isGuardian" placeholder="请选择是否为监护人" style="width: 100%">
                <el-option
                  v-for="item in yesNoList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
    </div>
    <div style="text-align: right" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model == 'add' ? '提交' : '修改' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div>
  </div>
</template>
  <script>
import { getProjectList } from '@/api/crmedical/project/project';
import { getDictionary } from '@/api/common.js';
import { getStore } from '@/util/store';
import {
  getMatetial,
  getTotalWarehouseWarnSetting,
  stockWarnSave,
  getWarehouseWarnSetting,
  saveFamilyMember
} from '../api/serveItemManage';
export default {
  components: {},

  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      projectList: [],
      relationshipList: [],
      yesNoList: [],
      form: {
        name: '',
        sex: '',
        tel: '',
        adress: '',
        relationship: '',
        isWatch: '',
        code: '',
      },
      formRules: {
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
        idNumber: [{ required: true, message: '身份证号不能为空', trigger: 'blur' }],
        //   nursinghomeId: [{ required: false, message: '项目名称不能为空', trigger: 'change' }],
      },
      matetialList: [],
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    getGenderByIdNumber(idNumber) {
      if (idNumber) {
        let genderCode; // 性别代码
        if (idNumber.length == 18) {
          // 二代身份证号码长度为18位（第17位为性别代码）
          genderCode = idNumber.charAt(16);
        } else if (idNumber.length == 15) {
          // 一代身份证号码长度为15位（第15位为性别代码）
          genderCode = idNumber.charAt(14);
        }
        if (genderCode && !isNaN(genderCode)) {
          // 两代身份证号码的性别代码都为男奇女偶
          if (parseInt(genderCode) % 2 == 0) {
            return 'female';
          }
          return 'male';
        }
      }
    },

    async initData() {
      getProjectList().then((res) => {
        this.projectList = res.data;
      });

      // getDictionary('nursinghome_relationship_type').then((res) => {
      //   this.relationshipList = res.data;
      // });
      getDictionary('yes_no').then((res) => {
        this.yesNoList = res.data;
      })
      if (this.model == 'add') {
        this.form = {
                      name: '',
                      sex: '',
                      tel: '',
                      adress: '',
                      relationship: '',
                      isWatch: '',
                      idNumber: '',
                    };
      } else {
        this.form = this._.cloneDeep(this.row);
      }
    },
    saveRecord() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
            saveFamilyMember({nursinghomeId:this.nursinghomeId,elderlyId:getStore({name:'elderId'}),...this.form}).then((res)=>{
              this.$message.success('操作成功！');
              this.$emit('success', this.form);
            });
          }
      });
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
  <style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
  